/* eslint-disable no-console */

const logout = (logoutUrl) => {
  fetch(logoutUrl, {
    credentials: 'include',
  })
    .catch((error) => {
      console.error('Error deleting cookie:', error);
    })
    .then(() => {
      window.location.reload();
    });

  document.cookie = '_nltg-jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC;';
};

export default logout;
